import * as $ from "jquery";
import * as ko from "knockout";
import Bao from "./../../../services/bao-service";
import baoDialog from "./../../../factories/bao-dialog";
import baoRouter from "./../../../services/bao-router";
import "./../../../bindings/bao-toggle-buttons";
function ChecklistSelectionViewModel(parent) {
    var self = this;
    self.parent = parent;
    self.Bao = Bao;
    self.Initialized = ko.observable(false);
    self.ComponentParameter = ko.observable();
    self.SearchEvaluation = function () {
        baoRouter.setHash("search/checkware-evaluation");
    };
    self.parent.Refresh = function () { };
    self.init = function () {
        var def = $.Deferred();
        if (!Bao.Utils.String.IsNullOrWhitespace(self.parent.Parameter())) {
            self.ComponentParameter(JSON.parse(self.parent.Parameter()));
        }
        Bao.post("Module/GetUserProfile").then(function (result) {
            self.ToggleChecklistSelectionModuleIconStyle(result);
        });
        self.Initialized(true);
        def.resolve();
        return def.promise();
    };
    self.ToggleChecklistSelectionModuleIconStyle = ko.observable(true);
    self.ChecklistSelectionModuleIconStyle = ko.observable("dashboard-icons");
    self.LargeChecklistSelectionModuleIconStyle = "dashboard-icons";
    self.SmallChecklistSelectionModuleIconStyle = "dashboard-icons-small";
    self.ToggleButtons = ko.observableArray([{
            value: "<i class=\"fal fa-th-large\"></i>",
            css: "btn-primary"
        }, {
            value: "<i class=\"fal fa-th\"></i>",
            css: "btn-primary"
        }]);
    self.ToggleChecklistSelectionModuleIconStyle.subscribe(function (newValue) {
        if (newValue) {
            self.ChecklistSelectionModuleIconStyle(self.LargeChecklistSelectionModuleIconStyle);
            self.SetNewChecklistSelectionModuleToggleState(newValue);
        }
        else {
            self.ChecklistSelectionModuleIconStyle(self.SmallChecklistSelectionModuleIconStyle);
            self.SetNewChecklistSelectionModuleToggleState(newValue);
        }
    });
    self.SetNewChecklistSelectionModuleToggleState = function (newValue) {
        return Bao.post("Module/SetUserProfile", JSON.stringify({
            toggleState: newValue
        })).then(function (result) { });
    };
}
export default ChecklistSelectionViewModel;